import { combineReducers } from 'redux';

import actionsReducer from './actions';

import byId from './data/byId';
import defrostingMediasReducer from './defrostingMedias';
import uiReducer from './ui';

/**
 * @typedef {{
 *   data: import("./data/byId").MediasDataEntity,
 *   ui: import("./ui").MediasUIReducer,
 *   actions: { uploads: unknown }
 * }} MediasReducer
 */

export default combineReducers({
  data: byId,
  ui: uiReducer,
  actions: actionsReducer,
  defrostingMedias: defrostingMediasReducer
});
